import * as yup from 'yup';

export const validationSchema = yup.object({
  code: yup.string().required('Code is required.'),
});
